import React from 'react';
import { FlightProvider } from 'legacyfrontend/contexts/FlightDetailsContext';
import BookingPage from './index';

const BookingPageWrapper = () => {
  return (
    <FlightProvider>
      <BookingPage />
    </FlightProvider>
  );
};

export default BookingPageWrapper;
